import React, {Component} from 'react'
import {debounce} from 'throttle-debounce'
import PropTypes from 'prop-types'

export default class ThrottleInput extends Component {
  constructor(props) {
    super(props)
    this.callAjax = debounce(500, this.callAjax)
  }
  printChange(e) {
    this.callAjax(e.target.value)
  }
  callAjax(value) {
    this.props.onCallback(value)
    // call ajax
  }
  render() {
    return <input className="form-control-sm" placeholder={this.props.placeholder} type="text" defaultValue={this.props.value} onKeyUp={this.printChange.bind(this)} />
  }
}

ThrottleInput.propTypes = {
  onCallback: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ThrottleInput.defaultProps = {
  placeholder: '',
  value: ''
}


// WEBPACK FOOTER //
// ./src/components/throttleInput/index.js